/**************************************************
 * Nombre:       Formulario_Espacio
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     1 Hr
 **************************************************/
import {Grid, Typography} from "@mui/material";
import IngresoTexto from "../../../Modulo_formularios/Componentes/IngresoTexto";
import {Flag, SchoolOutlined, ShortTextOutlined} from "@mui/icons-material";
import IngresoSelect from "../../../Modulo_formularios/Componentes/IngresoSelect";
import {ESTADOSPRODUCTO} from "../../../Constantes";
import IngresoImagenCrop from "../../../Modulo_formularios/Componentes/IngresoImagenCrop";
import IngresoFecha from "../../../Modulo_formularios/Componentes/IngresoFecha";
import IngresoHora from "../../../Modulo_formularios/Componentes/IngresoHora";

const Formulario_Espacio = ({...props}) => {

    return (
        <form noValidate style={{width: '100%'}}>
            <Grid
                container
                justifyContent={'flex-start'}
                alignItems={'flex-start'}
                size={{xs: 12, sm: 12, md: 12}}
                spacing={2}
            >

                <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start'}}>
                    <Typography sx={{fontSize: 14}}>**Imagen Principal de 640px por 400px (fondo transparente) de menos
                        de 300K de
                        peso</Typography>
                </Grid>

                <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start'}}>
                    <IngresoImagenCrop dato={'img'} alto={20} ancho={32} {...props}  />
                </Grid>


                <Grid container size={{xs: 6, sm: 6, md: 6}}>
                    <IngresoSelect Icono={Flag} nombre={'Estado'} dato={'estado'} {...props}
                                   requerido={'El estado es requerido'}
                                   opciones={ESTADOSPRODUCTO.map((it) => it.nombre)}
                    />
                </Grid>

                <Grid container size={12}>
                    <IngresoTexto Icono={ShortTextOutlined} nombre={'Nombre Resaltado'}
                                  dato={'nombreResaltado'} {...props}

                    />
                </Grid>

                <Grid container size={{xs: 12, sm: 12, md: 12}}>
                    <IngresoTexto lineas={2} nombre={'Resto del Nombre'}
                                  dato={'nombre'} {...props}
                                  requerido={'Campo requerido'}
                    />
                </Grid>

                <Grid container size={12}>
                    <IngresoTexto Icono={SchoolOutlined} nombre={'Profesional'}
                                  dato={'profesional'} {...props}

                    />

                </Grid>

                <Grid container size={6}>
                    <IngresoFecha nombre={'Fecha'}
                                  dato={'fechaEspacio'} {...props}
                    />
                </Grid>

                <Grid container size={6}>
                    <IngresoHora nombre={'Hora'}
                                 dato={'horaEspacio'} {...props}
                    />
                </Grid>


            </Grid>

        </form>

    )

}
export default Formulario_Espacio